import { render, staticRenderFns } from "./friends-caregiversaathi.vue?vue&type=template&id=23426a07"
import script from "./friends-caregiversaathi.vue?vue&type=script&lang=js"
export * from "./friends-caregiversaathi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports